import { parseISO } from 'date-fns';

export function defaultStartDate(): Date | null {
  if (sessionStorage.startTime) {
    return parseISO(sessionStorage.startTime);
  }
  return null;
}

export function defaultStartTime(): Date | null {
  if (sessionStorage.startTime) {
    return parseISO(sessionStorage.startTime);
  }
  return null;
}

export function defaultEndTime(): Date | null {
  if (sessionStorage.startTime && sessionStorage.endTime) {
    return parseISO(sessionStorage.endTime);
  }
  return null;
}

export default {
  defaultStartDate,
  defaultStartTime,
  defaultEndTime,
};
